var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5504 21.2137C46.9551 23.2279 48.1802 30.7607 43.5081 37.9216C39.2989 44.373 32.99 46.4059 31.176 46.9603C22.6402 49.5684 11.7847 47.3493 5.26223 39.4007C-1.57748 31.0653 0.0794814 20.9759 0.427171 18.8581C0.897096 15.9959 2.34055 7.20693 9.71701 2.6432C19.737 -3.55627 31.9241 3.47421 34.3813 4.99875C36.6217 6.38906 44.5626 11.316 46.5504 21.2137Z",
    strokeWidth: 3,
    transform: "scale(0.95 0.95)",
    "transform-origin": 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.d4383cf4.svg";
export { ForwardRef as ReactComponent };